import { useBridgeState } from '@digitaz/bridge-sdk-client';
import { InteractionSourceEnum } from '../graphql/types';
import useScreenSize from './useScreenSize';

export const useAnalyticLogSource = (): InteractionSourceEnum => {
  const { isWebView } = useBridgeState();
  const { isSmall } = useScreenSize();

  if (isWebView) return InteractionSourceEnum.App;

  if (isSmall) return InteractionSourceEnum.Mobile;

  return InteractionSourceEnum.Desktop;
};
